var _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStethoscope = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  className: "stethoscope_svg__icon stethoscope_svg__icon-tabler stethoscope_svg__icon-tabler-stethoscope",
  width: 24,
  height: 24,
  strokeWidth: 1.5,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  stroke: "none"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M6 4H5a2 2 0 0 0-2 2v3.5h0a5.5 5.5 0 0 0 11 0V6a2 2 0 0 0-2-2h-1"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M8 15a6 6 0 1 0 12 0v-3M11 3v2M6 3v2"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 10,
  r: 2
})));
export default SvgStethoscope;